
import state from './moduleMailSendResumeState.js'
import mutations from './moduleMailSendResumeMutations.js'
import actions from './moduleMailSendResumeActions.js'
import getters from './moduleMailSendResumeGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
